import { BlockEditProps } from "@wordpress/blocks";
import type { BlockAttributes } from "./block.json";
import {
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import "../slider/swiper";
import ImageEditor from "../../../source/components/ImageEditor";

const ALLOWED_BLOCKS = ["core/paragraph"];

export default function NewsletterEditor(
  props: BlockEditProps<BlockAttributes>
) {
  const blockProps = useBlockProps({
    className: "newsletter alignfull position-relative",
  });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "copy-xl",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      template: [
        [
          "core/paragraph",
          {
            content:
              props.attributes.content || "Wir halten dich auf dem Laufenden",
            className: "copy-xl",
          },
        ],
      ],
    }
  );

  return (
    <>
      <div {...blockProps}>
        <ImageEditor
          attributes={props.attributes}
          setAttributes={props.setAttributes}
          prefix="image"
          placeholderClassName="img-placeholder"
        />
        <div className="container h-100 position-relative">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <div {...innerBlocksProps}></div>
            </div>
            <div className="col-xl-6 d-flex flex-column flex-xl-row gap-2 justify-content-center align-items-center">
              <input type="text" placeholder="E-Mail Adresse eingeben" />
              <div className="ms-1">
                <a className="button">ABONNIEREN</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
